import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import TranslationHelper from '../../../../../helpers/TranslationHelper';

import { useStyles } from '../Themable.hooks';

import { CustomToggleButtonGroup } from '../../../../../components/Styled/StyledToggleButtonGroup';
import ToggleButtonWithError from '../../../../../components/ToggleButtonWithError';
import LoadingSpinner from '../../../../../components/loadingSpinner/LoadingSpinner';
import TaskForm from '../../../../../features/TaskForm/TaskForm';
import AttributesForm from '../../../../../features/Attributes/components/AttributesForm';
import { FormikErrors, FormikValues } from 'formik';
import { IEditTaskDialogFormValues } from '../types';
import { ITaskForm } from '../../../../../state/ui/forms';
import { restGetAttributes } from '../../../../../features/Attributes/services';
import { SYSTEM_OBJECT_IDS } from '../../../../../constants/dictionaries/SystemObjects';
import { prepareAttributesFormData } from '../../../../../features/Attributes/utils';
import { TAttributeDictionary } from '../../../../../features/Attributes/types';
import { fetchTaskCopyData, fetchTaskEditData } from '../utils/prepareTaskData';

interface IOwnProps {
    formValues: {
        data: ITaskForm;
        attributes: TAttributeDictionary;
    };
    errors: FormikErrors<IEditTaskDialogFormValues>;
    setFieldValue: (fieldname: string, v: any) => void;
    loading: boolean;
    setLoading: (bool: boolean) => void;
    handleAddLocation: (values: FormikValues) => void;
    mode: 'add' | 'edit' | 'copy';
    routeAssigned: boolean | null | undefined;
    taskId?: number;
}

export const TaskModificationForm = ({
    formValues,
    errors,
    setFieldValue,
    loading,
    setLoading,
    handleAddLocation,
    mode,
    routeAssigned,
    taskId,
}: IOwnProps) => {
    const [alignment, setAlignment] = useState<'data' | 'attributes'>('data');

    const classes = useStyles();

    useEffect(() => {
        if (alignment === 'data' && errors.attributes && !errors.data) {
            setAlignment('attributes');
        }
        if (alignment === 'attributes' && errors.data && !errors.attributes) {
            setAlignment('data');
        }
    }, [errors]);

    useEffect(() => {
        setLoading(true);

        const attributePromise = restGetAttributes(SYSTEM_OBJECT_IDS.Task);
        if (!taskId) {
            attributePromise.then((attrData) => {
                const attributes = prepareAttributesFormData(
                    attrData,
                    SYSTEM_OBJECT_IDS.Task,
                    {}
                );

                setFieldValue('attributes', attributes);
                setLoading(false);
            });
        } else if (mode === 'copy') {
            fetchTaskCopyData(
                attributePromise,
                setFieldValue,
                taskId,
                formValues,
                setLoading
            );
        } else if (mode === 'edit') {
            fetchTaskEditData(
                attributePromise,
                setFieldValue,
                taskId,
                formValues,
                setLoading
            );
        }
    }, []);
    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: 'data' | 'attributes'
    ) => {
        if (newAlignment !== null) {
            setAlignment(newAlignment);
        }
    };
    if (loading) {
        return (
            <div className={classes.spinner}>
                <LoadingSpinner progressSize="8em" />
            </div>
        );
    }
    return (
        <>
            <CustomToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleChange}
                aria-label={TranslationHelper.translate('Choose section')}
                fullWidth
                size="medium"
            >
                <ToggleButtonWithError
                    value="data"
                    labelKey="Data"
                    hasError={!isEmpty(errors.data)}
                />

                <ToggleButtonWithError
                    value="attributes"
                    labelKey="Attributes"
                    hasError={!isEmpty(errors.attributes)}
                />
            </CustomToggleButtonGroup>
            {alignment === 'data' && (
                <TaskForm
                    mode={mode}
                    errors={errors.data}
                    values={formValues.data}
                    setFieldValue={setFieldValue}
                    isSubmitting={false}
                    onAddLocation={() => handleAddLocation(formValues.data)}
                    routeAssigned={routeAssigned}
                />
            )}
            {alignment === 'attributes' && (
                <AttributesForm
                    errors={errors.attributes}
                    attributes={formValues.attributes}
                    setFieldValue={setFieldValue}
                />
            )}
        </>
    );
};
